import store from 'store'
import queryString from 'query-string'
// import packageInfo from '../../../package.json'

// eslint-disable-next-line import/no-cycle
import { updateToken } from '../jwt'

function RestClient(apiURL, fetchFunc, tokenKey, getAuthFunc) {
  const self = this

  self.apiURL = apiURL

  self.fetch = fetchFunc

  // const HEADER_APP = 'x-ni-sb-app'
  // const HEADER_APP_VERSION = 'x-ni-sb-app-version'

  const applyTokenForOptions = (options) => {
    if (options.headers == null) {
      options.headers = {}
    }

    // 디바이스 및 버전 정보 추가
    // options.headers[HEADER_APP] = 'Web App'
    // options.headers[HEADER_APP_VERSION] = packageInfo.version

    if (tokenKey != null) {
      const token = store.get(tokenKey)
      if (token != null) {
        if (getAuthFunc == null) {
          options.headers.authorization = `JWT ${token}`
        } else {
          const { key, value } = getAuthFunc(token)
          options.headers[key] = value
        }
      }
    }
  }

  const applyTokenForXHR = (xhr) => {
    // 디바이스 및 버전 정보 추가
    // xhr.setRequestHeader(HEADER_APP, 'Web App')
    // xhr.setRequestHeader(HEADER_APP_VERSION, packageInfo.version)

    if (tokenKey != null) {
      const token = store.get(tokenKey)
      if (token != null) {
        if (getAuthFunc == null) {
          xhr.setRequestHeader('authorization', `JWT ${token}`)
        } else {
          const { key, value } = getAuthFunc(token)
          xhr.setRequestHeader(key, value)
        }
      }
    }
  }

  const processResponse = (reqPromise) => {
    return new Promise((resolve, reject) => {
      if (!reqPromise) {
        throw new Error('Request promise is null or undefined')
      }

      reqPromise
        .then(async (response) => {
          if (!response) {
            throw new Error('Response is null or undefined')
          }

          const code = response.status
          const data =
            response.json != null && code !== 204 && code !== 304
              ? await response.json()
              : { message: response.message || 'No message provided' }
          console.log(' data : ', data)
          if ((code >= 200 && code < 300) || code === 304) {
            resolve({
              origin: response,
              data,
            })
          } else {
            const error = new Error(data.message || data.detail)
            error.origin = {
              code,
              ...data,
            }
            reject(error)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  self.get = (url, params, opts) => {
    let api = self.apiURL + url

    if (params != null) {
      const search = queryString.stringify(params)
      if (search != null) {
        api += `?${search}`
      }
    }

    const options = {
      method: 'GET',
      ...opts,
    }

    applyTokenForOptions(options)

    const ret = self.fetch.call(window, api, options)

    return processResponse(ret)
  }

  self.post = (url, params, opts) => {
    const api = self.apiURL + url

    const options = {
      method: 'POST',
      body: JSON.stringify(params),
      ...opts,
    }

    if (options.headers == null) {
      options.headers = {}
    }

    options.headers['Content-Type'] = 'application/json'
    // 디바이스 및 버전 정보 추가
    // options.headers[HEADER_APP] = 'Web App'
    // options.headers[HEADER_APP_VERSION] = packageInfo.version

    applyTokenForOptions(options)

    const ret = self.fetch.call(window, api, options)

    return processResponse(ret)
  }

  self.put = (url, params, opts) => {
    const api = self.apiURL + url

    const options = {
      method: 'PUT',
      body: JSON.stringify(params),
      ...opts,
    }

    if (options.headers == null) {
      options.headers = {}
    }

    options.headers['Content-Type'] = 'application/json'
    // 디바이스 및 버전 정보 추가
    // options.headers[HEADER_APP] = 'Web App'
    // options.headers[HEADER_APP_VERSION] = packageInfo.version

    applyTokenForOptions(options)

    const ret = self.fetch.call(window, api, options)

    return processResponse(ret)
  }

  self.patch = (url, params, opts) => {
    const api = self.apiURL + url

    const options = {
      method: 'PATCH',
      body: JSON.stringify(params),
      ...opts,
    }

    if (options.headers == null) {
      options.headers = {}
    }

    options.headers['Content-Type'] = 'application/json'
    // 디바이스 및 버전 정보 추가
    // options.headers[HEADER_APP] = 'Web App'
    // options.headers[HEADER_APP_VERSION] = packageInfo.version

    applyTokenForOptions(options)

    const ret = self.fetch.call(window, api, options)

    return processResponse(ret)
  }

  self.delete = (url, params, opts) => {
    const api = self.apiURL + url

    const options = {
      method: 'DELETE',
      body: JSON.stringify(params),
      ...opts,
    }

    if (options.headers == null) {
      options.headers = {}
    }

    options.headers['Content-Type'] = 'application/json'
    // 디바이스 및 버전 정보 추가
    // options.headers[HEADER_APP] = 'Web App'
    // options.headers[HEADER_APP_VERSION] = packageInfo.version

    applyTokenForOptions(options)

    const ret = self.fetch.call(window, api, options)

    return processResponse(ret)
  }

  self.xhrGet = (url, params, onProgress, onBeforeSend, opts) => {
    // console.log(onProgress)
    const promise = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      // xhr.withCredentials = true;
      xhr.addEventListener('progress', (e) => {
        if (onProgress != null) {
          onProgress(e, (e.loaded * 100) / e.total)
        }
      })
      xhr.addEventListener('load', (e) => {
        const { status } = e.target
        if (status >= 200 && status < 400) {
          let json = {}
          const body = xhr.response
          if (
            (xhr.responseType === '' || xhr.responseType === 'text') &&
            xhr.responseText != null &&
            xhr.responseText.charAt(0) === '{'
          ) {
            json = JSON.parse(xhr.responseText)
          }
          resolve({ status: xhr.status, body, json, data: json, event: e, xhr })
        } else if (status === 401) {
          updateToken()
            .then(() => {
              startReq()
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          reject(e.target.response)
        }
      })

      xhr.addEventListener('error', (err) => reject(err))
      xhr.addEventListener('abort', (e) => reject(e))

      let api = self.apiURL + url

      if (params != null) {
        const search = queryString.stringify(params)
        if (search != null) {
          api += `?${search}`
        }
      }

      function startReq() {
        xhr.open('GET', api, true)

        // xhr.setRequestHeader('Content-Type', 'mutipart/form-data');

        applyTokenForXHR(xhr)

        if (opts != null && opts.headers != null) {
          Object.entries(opts.headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value)
          })
        }

        if (onBeforeSend != null) {
          onBeforeSend(xhr)
        }

        xhr.send()
      }

      startReq()
    })

    return promise
  }

  self.xhrPost = (url, formData, onProgress, onBeforeSend, opts) => {
    // console.log(onProgress)
    const promise = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      // xhr.withCredentials = true;
      if (onProgress != null) {
        xhr.upload.addEventListener('progress', (e) => onProgress(e, (e.loaded * 100) / e.total))
      }
      xhr.addEventListener('load', (e) => {
        const { status } = e.target
        if (status >= 200 && status < 400) {
          let json = {}
          const body = xhr.response
          if (
            (xhr.responseType === '' || xhr.responseType === 'text') &&
            xhr.responseText != null &&
            xhr.responseText.charAt(0) === '{'
          ) {
            json = JSON.parse(xhr.responseText)
          }
          resolve({ status: xhr.status, body, json, data: json, event: e, xhr })
        } else if (status === 401) {
          updateToken()
            .then(() => {
              startReq()
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          reject(e.target.response)
        }
      })

      xhr.addEventListener('error', (err) => reject(err))
      xhr.addEventListener('abort', (e) => reject(e))

      const api = self.apiURL + url

      function startReq() {
        xhr.open('POST', api, true)

        // xhr.setRequestHeader('Content-Type', 'mutipart/form-data');

        applyTokenForXHR(xhr)

        if (opts != null && opts.headers != null) {
          Object.entries(opts.headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value)
          })
        }

        if (onBeforeSend != null) {
          onBeforeSend(xhr)
        }

        if (formData != null) {
          xhr.send(formData)
        } else {
          xhr.send()
        }
      }

      startReq()
    })

    return promise
  }

  self.xhrPut = (url, formData, onProgress, onBeforeSend, opts) => {
    // console.log(onProgress)
    const promise = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      // xhr.withCredentials = true;
      if (onProgress != null) {
        xhr.upload.addEventListener('progress', (e) => onProgress(e, (e.loaded * 100) / e.total))
      }
      xhr.addEventListener('load', (e) => {
        const { status } = e.target
        if (status >= 200 && status < 400) {
          let json = {}
          const body = xhr.response
          if (
            (xhr.responseType === '' || xhr.responseType === 'text') &&
            xhr.responseText != null &&
            xhr.responseText.charAt(0) === '{'
          ) {
            json = JSON.parse(xhr.responseText)
          }
          resolve({ status: xhr.status, body, json, data: json, event: e, xhr })
        } else if (status === 401) {
          updateToken()
            .then(() => {
              startReq()
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          reject(e.target.response)
        }
      })

      xhr.addEventListener('error', (err) => reject(err))
      xhr.addEventListener('abort', (e) => reject(e))

      const api = self.apiURL + url

      function startReq() {
        xhr.open('PUT', api, true)

        // xhr.setRequestHeader('Content-Type', 'mutipart/form-data');

        applyTokenForXHR(xhr)

        if (opts != null && opts.headers != null) {
          Object.entries(opts.headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value)
          })
        }

        if (onBeforeSend != null) {
          onBeforeSend(xhr)
        }

        if (formData != null) {
          xhr.send(formData)
        } else {
          xhr.send()
        }
      }

      startReq()
    })

    return promise
  }

  self.xhrPatch = (url, formData, onProgress, onBeforeSend, opts) => {
    // console.log(onProgress)
    const promise = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      // xhr.withCredentials = true;
      if (onProgress != null) {
        xhr.upload.addEventListener('progress', (e) => onProgress(e, (e.loaded * 100) / e.total))
      }
      xhr.addEventListener('load', (e) => {
        const { status } = e.target
        if (status >= 200 && status < 400) {
          let json = {}
          const body = xhr.response
          if (
            (xhr.responseType === '' || xhr.responseType === 'text') &&
            xhr.responseText != null &&
            xhr.responseText.charAt(0) === '{'
          ) {
            json = JSON.parse(xhr.responseText)
          }
          resolve({ status: xhr.status, body, json, data: json, event: e, xhr })
        } else if (status === 401) {
          updateToken()
            .then(() => {
              startReq()
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          reject(e.target.response)
        }
      })

      xhr.addEventListener('error', (err) => reject(err))
      xhr.addEventListener('abort', (e) => reject(e))

      const api = self.apiURL + url

      function startReq() {
        xhr.open('PATCH', api, true)

        // xhr.setRequestHeader('Content-Type', 'mutipart/form-data');

        applyTokenForXHR(xhr)

        if (opts != null && opts.headers != null) {
          Object.entries(opts.headers).forEach(([key, value]) => {
            xhr.setRequestHeader(key, value)
          })
        }

        if (onBeforeSend != null) {
          onBeforeSend(xhr)
        }

        if (formData != null) {
          xhr.send(formData)
        } else {
          xhr.send()
        }
      }

      startReq()
    })

    return promise
  }
}

export default RestClient
